import React from "react";
import "../MessageItem.css";

/**
 * Displays a WhatsApp-style reaction emoji badge on the bottom-right corner of a message
 */
const ReactionBadge = ({ reaction }) => {
	if (!reaction) return null;
	return <span className="reaction-badge">{reaction}</span>;
};

export default ReactionBadge;
